import {Image} from "antd";

const BirdIcon = () => {
    return <Image src={`${process.env.REACT_APP_ASSET_HOST}/assets/icons/messenger-bird.png`} width={25}/>;
}

export default BirdIcon;